<template>
  <el-dialog :title="`${companyName}物流跟踪`" :visible.sync="dialogLogistics" :before-close="close" width="400px" :close-on-click-modal="false">
    <el-timeline reverse v-if="companyName == '同城快递'">
      <el-timeline-item v-for="(item, i) in Logistics" :key="i" :timestamp="item.scanTime">{{item.remark}}</el-timeline-item>
    </el-timeline>
    <el-timeline reverse v-else>
      <el-timeline-item v-show="Logistics.length > 0" v-for="(item, i) in Logistics" :key="i" :timestamp="item.scanTime">{{item.remark}}</el-timeline-item>
    </el-timeline>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script lang="js">
export default {
  props: { companyName:  String, Logistics:  Array, dialogLogistics:  Boolean }, // 接收父组件传递的参数
  methods: {
    // 关闭弹框
    close() {
      this.$emit('dialogLogisticsBack', false);
    },
  }
}
</script>